import React from "react";
import stylesSCTree from "../SCTree.module.css";
import {TreeDOMHelper} from "./TreeHelper";
import ReactDOM from "react-dom";
import {TreeAlignmentButtons} from "./documentButtons/TreeAlignmentButtons";

export class TreeScrollableDocument extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            text: ''
        };
    }


    // Verifica se due elementi evidenziati sono "adiacenti" nel documento (es. "lavoro" e "lungo"
    // trovati dalla stessa ricerca multi-parola), separati al massimo da pochi caratteri di
    // spazio/punteggiatura, così da poterli trattare come un'unica occorrenza da mostrare insieme.
    _areMarksAdjacent(el1, el2) {
        let node = el1.nextSibling;
        let gapText = '';
        let hops = 0;
        while (node && node !== el2 && hops < 5) {
            gapText += node.textContent || '';
            if (gapText.length > 3) return false;
            node = node.nextSibling;
            hops++;
        }
        return node === el2 && /^[\s.,;:'"()-]*$/.test(gapText);
    }

    componentDidMount() {
        if (typeof this.props.textToScrollJson !== 'undefined' && this.props.textToScrollJson != null) {
            var markedClass = stylesSCTree["tree-markYellow"];
            var context = TreeDOMHelper.markElementText('#scrollable-document-container', this.props.textToScrollJson.word, markedClass);
            var marked = context.getElementsByClassName(markedClass);

            // Raggruppa elementi adiacenti (es. parole diverse della stessa ricerca multi-parola,
            // "lavoro" + "lungo") in un'unica occorrenza, così da mostrarli/nasconderli insieme
            // invece di trattarli come occorrenze indipendenti.
            var groups = [];
            for (var markedItem of marked) {
                var lastGroup = groups.length > 0 ? groups[groups.length - 1] : null;
                if (lastGroup && this._areMarksAdjacent(lastGroup[lastGroup.length - 1], markedItem)) {
                    lastGroup.push(markedItem);
                } else {
                    groups.push([markedItem]);
                }
            }

            var count = 0;
            for (var group of groups) {
                if (this.props.textToScrollJson.position !== count) {
                    group.forEach(el => el.classList.add(stylesSCTree['tree-markYellow-hidden']));
                } else {
                    group[0].scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                        inline: "nearest"
                    });
                }

                if (count === 0) {
                    this.setState({text: group[0].innerText})
                }
                count++;
            }

            ReactDOM.render(<TreeAlignmentButtons
                    otherFilename={this.props.otherFilename}
                    otherLabel={this.props.otherLabel}
                    projectName={this.props.projectName}
                    parentKey={this.props.parentKey}
                    filename={this.props.filename}
                    isDirect={this.props.isDirect}
                    textToScrollJson={this.props.textToScrollJson}
                    position={typeof this.props.textToScrollJson !== 'undefined' && this.props.textToScrollJson != null ? this.props.textToScrollJson.position : null}
                    markedCount={groups.length}
                    resHtml={this.props.resHtml}/>
                , document.getElementById(this.props.renderFooterElement));
        }
    }

    render() {
        return <div id={'scrollable-document-container'}
                    style={{height: '100%', overflow: 'auto', padding: '4px'}}
                    dangerouslySetInnerHTML={{__html: this.props.resHtml}}/>
    }
}